import { render, staticRenderFns } from "./upgradeTaskModel.vue?vue&type=template&id=6d73f97c&scoped=true&"
import script from "./upgradeTaskModel.vue?vue&type=script&lang=js&"
export * from "./upgradeTaskModel.vue?vue&type=script&lang=js&"
import style0 from "./upgradeTaskModel.vue?vue&type=style&index=0&id=6d73f97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d73f97c",
  null
  
)

export default component.exports